import { render, staticRenderFns } from "./Info_ListItemOrdered.vue?vue&type=template&id=cf32f8e6&scoped=true&"
import script from "./Info_ListItemOrdered.vue?vue&type=script&lang=js&"
export * from "./Info_ListItemOrdered.vue?vue&type=script&lang=js&"
import style0 from "./Info_ListItemOrdered.vue?vue&type=style&index=0&id=cf32f8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf32f8e6",
  null
  
)

export default component.exports